/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createMarkOrdersExportedResponseFromDiscriminatorValue, serializeMarkOrdersExportedRequest, serializeMarkOrdersExportedResponse, type ErrorResponse, type InternalErrorResponse, type MarkOrdersExportedRequest, type MarkOrdersExportedResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/exported
 */
export interface ExportedRequestBuilder extends BaseRequestBuilder<ExportedRequestBuilder> {
    /**
     * Stamps the given orders as exported to an external system (exportedAt, exportedBy). Intended for integrations such as the SQL Connector after they have created the orders in the accounting system. Idempotent: stamping again updates the timestamp. Ids that do not belong to the caller's organization are returned in notFound and never stamped.
     * @param body Stamps orders as exported to an external system. Sent by an integration (for example the SQLConnector after it has written the orders into QuickBooks Desktop) once the external recordexists, so the admin's order list stops showing them as "not exported".
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<MarkOrdersExportedResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: MarkOrdersExportedRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<MarkOrdersExportedResponse | undefined>;
    /**
     * Stamps the given orders as exported to an external system (exportedAt, exportedBy). Intended for integrations such as the SQL Connector after they have created the orders in the accounting system. Idempotent: stamping again updates the timestamp. Ids that do not belong to the caller's organization are returned in notFound and never stamped.
     * @param body Stamps orders as exported to an external system. Sent by an integration (for example the SQLConnector after it has written the orders into QuickBooks Desktop) once the external recordexists, so the admin's order list stops showing them as "not exported".
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MarkOrdersExportedRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ExportedRequestBuilderUriTemplate = "{+baseurl}/api/orders/exported";
/**
 * Metadata for all the requests in the request builder.
 */
export const ExportedRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ExportedRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createMarkOrdersExportedResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeMarkOrdersExportedRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
